import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_ENDPOINTS from '../../config/api';
import VenueLocationPicker from './VenueLocationPicker';

const VenueManagement = () => {
  const [venue, setVenue] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mapOpen, setMapOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    address: '',
    latitude: '',
    longitude: '',
  });

  useEffect(() => {
    fetchVenue();
  }, []);

  const fetchVenue = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.ADMIN_VENUE);
      if (response.data.success && response.data.venue) {
        setVenue(response.data.venue);
        setFormData({
          name: response.data.venue.name || '',
          address: response.data.venue.address || '',
          latitude: response.data.venue.latitude != null ? String(response.data.venue.latitude) : '',
          longitude: response.data.venue.longitude != null ? String(response.data.venue.longitude) : '',
        });
      }
    } catch (error) {
      console.error('Error fetching venue:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLocationChange = ({ latitude, longitude, address }) => {
    setFormData((prev) => ({
      ...prev,
      latitude,
      longitude,
      ...(address !== undefined ? { address } : {}),
    }));
  };

  const handleSave = async () => {
    if (!formData.name.trim()) {
      alert('Please enter a venue name.');
      return;
    }
    if (!formData.latitude || !formData.longitude) {
      const proceed = window.confirm(
        'No map pin set yet. Guests may not see the venue on the map. Save anyway?'
      );
      if (!proceed) return;
    }

    try {
      const data = venue ? { ...formData, id: venue.id } : formData;
      await axios.post(API_ENDPOINTS.ADMIN_VENUE, data);
      alert('Venue saved successfully!');
      fetchVenue();
    } catch (error) {
      alert('Error saving venue');
    }
  };

  if (loading) return <div className="loading">Loading venue...</div>;

  return (
    <div className="venue-management">
      <h1>Venue Management</h1>
      <p className="venue-management-intro">
        Set your wedding venue name, address, and pin the exact spot on the map for guests.
      </p>
      <div className="settings-form">
        <div className="form-group">
          <label>Venue Name</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            placeholder="e.g. St. Mary's Church"
          />
        </div>
        <div className="form-group">
          <label>Address</label>
          <textarea
            value={formData.address}
            onChange={(e) => setFormData({ ...formData, address: e.target.value })}
            onFocus={() => setMapOpen(true)}
            rows="3"
            placeholder="Street, city, country — map opens below to pin the exact spot"
          />
        </div>
        <div className="form-group">
          <label>Map location</label>
          <VenueLocationPicker
            latitude={formData.latitude}
            longitude={formData.longitude}
            address={formData.address}
            onLocationChange={handleLocationChange}
            mapOpen={mapOpen}
            onMapOpenChange={setMapOpen}
          />
        </div>
        <button type="button" className="btn-primary" onClick={handleSave}>
          Save Venue
        </button>
      </div>
    </div>
  );
};

export default VenueManagement;
